import { useSelector } from 'react-redux';
import CardActions from '@mui/material/CardActions';
import CreditsAmountSlider from '../CreditsAmountSlider';
import CreditsPrice from '../CreditsPrice';
import PurchaseButton from '../PurchaseButton';
import { selectIsSubscribed } from '../../../../store/account/selectors';
import useCreditPrice from '../../../../hooks/useCreditPrice';
import {
  StyledCard,
  StyledCardContent,
  StyledCardHeader,
  StyledSliderWrapper,
} from './styled';

const TopUpSelector = () => {
  const isSubscribed = useSelector(selectIsSubscribed);

  const price = useCreditPrice();

  if (price === null || isSubscribed) {
    return null;
  }

  return (
    <StyledCard>
      <StyledCardHeader
        title="Buy More Credits"
        subheader="Purchase additional credits to continue generating AI music tracks. Credits never expire."
      />
      <StyledCardContent>
        <StyledSliderWrapper>
          <CreditsAmountSlider />
        </StyledSliderWrapper>
        <CreditsPrice
          pricePerCredit={price.priceCents}
          labels={{
            totalUnits: 'Total track generations',
            costPerUnit: 'Cost per track generation',
            total: 'One-off payment',
          }}
        />
      </StyledCardContent>
      <CardActions>
        <PurchaseButton />
      </CardActions>
    </StyledCard>
  );
};
export default TopUpSelector;
